export const isAuthenticated = user => !!user;

export const isAllowed = () => {
    return getUserAuth() !== null;
};

export const setUserAuth = (data) => {
    window.localStorage.setItem("user_data", JSON.stringify(data));
};

export const getUserAuth = () => {
    return JSON.parse(window.localStorage.getItem("user_data"));
};

export const hasRole = (user, roles) =>
    roles.some(role => user.roles.includes(role));

export const getUserToken = () => {
    return isAllowed() ? JSON.parse(window.localStorage.getItem("user_data")).token : "";
};

export const getCourierBusinessId = () => {
    return isAllowed() ? JSON.parse(window.localStorage.getItem("user_data")).business_id : "";
};

export const payStackSecretToken = () => {
    return "sk_live_aa938a549e42fc4f519148a0cf67e42631158d70";
};

export const getUserName = () => {
    return isAllowed() ? JSON.parse(window.localStorage.getItem("user_data")).name : "";
};

export const getUserType = () => {
    return isAllowed() ? JSON.parse(window.localStorage.getItem("user_data")).type : "";
};

export const getUserPhoneNumber = () => {
    return isAllowed() ? JSON.parse(window.localStorage.getItem("user_data")).phone_number : "";
};

export const logout = () => {
    window.localStorage.clear();
    window.localStorage.href = "/";
};
